export class RegularAttribute {
  readonly value: string;
  readonly label: string;

  constructor(label: string, value: string) {
    this.label = label;
    this.value = value;
  }
}
